
/*
 *
 * ┌─────────────────────────────────────┐
 * │                                     │
 * │             ________  ___           │
 * │            / ___/ _ \/ _ )          │
 * │           / /__/ ___/ _  |          │
 * │           \___/_/  /____/           │
 * │                                     │
 * └─────────────────────────────────────┘
 *
 */




/*-----------------------------------------------------------------------------------*/
/*  00. COMPONENTS IMPORTS
/*-----------------------------------------------------------------------------------*/

import $ from 'domtastic'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { CSSPlugin } from 'gsap/all'
import Swiper, { Keyboard } from 'swiper'
import { BiskitCookieConsent } from 'reed-biskit'

import Browser from '@comps/Browser'
import Router from '@comps/Router'
import Layout from '@comps/Layout'

gsap.registerPlugin(CSSPlugin, ScrollTrigger)
gsap.config({ nullTargetWarn: false })
Swiper.use([Keyboard])

const APP = window.APP || {}




/*-----------------------------------------------------------------------------------*/
/*  01. INIT
/*-----------------------------------------------------------------------------------*/

const initApp = () => {
    window.APP = APP

    APP.Browser = new Browser()
    APP.Router  = new Router()
    APP.Layout  = new Layout()

    if (document.querySelector('#biskit-cookie-panel')) {
        APP.CookieConsent = new BiskitCookieConsent({
            selector: '#biskit-cookie-panel',
            consentCallback: (consent) => {
                if (window.biskitSdk.consentFunction) {
                    window.biskitSdk.consentFunction(consent)
                }
                $(document).trigger('cookieConsentChanged')

                if (consent.functional) {
                    gtag('consent', 'update', {
                        analytics_storage: 'granted'
                    })
                } else {
                    gtag('consent', 'update', {
                        analytics_storage: 'denied'
                    })
                }

                if (consent.ads) {
                    gtag('consent', 'update', {
                        ad_storage: 'granted'
                    })
                } else {
                    gtag('consent', 'update', {
                        ad_storage: 'denied'
                    })
                }
            },
        })
    }
}

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    initApp()
} else {
    document.addEventListener('DOMContentLoaded', initApp)
}



